export default __webpack_public_path__ + "154880dddd1b9da6bda277d054bc2ba1.png";